module.exports = __webpack_public_path__ + "img/Reports-Assessmentgry.e2d0e087.svg";